// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `p-treeSelect.block .p-treeSelect{ display: block }`, "",{"version":3,"sources":["webpack://./src/app/modules/ngx-components/lib/wrappers/components/tree-select.ts"],"names":[],"mappings":"AAAA,kCAAkC,eAAe","sourcesContent":["p-treeSelect.block .p-treeSelect{ display: block }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
